import apiClient from '../apiClient';

const API_URL = '/art/siniestros/comentarios';

export const getComentariosPorSiniestro = async (idSiniestro) => {
    const response = await apiClient.get(`${API_URL}/siniestro/${idSiniestro}`);
    return response.data;
};

export const crearComentario = async (data) => {
    const response = await apiClient.post(API_URL, data);
    return response.data;
};

export const actualizarComentario = async (id, data) => {
    const response = await apiClient.put(`${API_URL}/${id}`, data);
    return response.data;
};

export const eliminarComentario = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

